import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import DpReportTable from "../../Components/ReportTables/DpReportTable";
import { Constants, DP_TYPE_OPTIONS } from "../../CommonMethhods/Constants";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import DurationChangeComponent from "./DurationChangeComponent";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function DpReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  // const userType = localStorage.getItem("userType").toLowerCase();
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase()
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [gridVal, setGridVal] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [noReportFound, setNoReportFound] = useState(false);
  const [dateErrorResp, setDateErrorResp] = useState(false);
  const [noNameFoundError, setNoNameFoundError] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [show, setShow] = useState(false);
  const [blankClientCodeError, setBlankClientCodeError] = useState(false);
  const [count, setCount] = useState();
  const [selection, setSelection] = useState("bill-tran");
  const [flag, setFlag] = useState("tran");
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration,setSelectDuration]=useState("")
  const [depository, setDepository] = useState("cdsl");

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };
    let encPayload =
      userType === "partner" || partnerRoleNew === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        userType === "partner" || partnerRoleNew === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,

        userType === "partner" || partnerRoleNew === "partner" ? `${encPayload}` : `"${encPayload}"`,
        // {
        //   headers: {
        //     "Content-Type":
        //       userType === "partner" || partnerRoleNew === "partner" ? "text/plain" : "application/json",
        //     Authorization: `Bearer ${partnerRoleNew === "partner" ? partnerSsoToken : storeToken}`,
        //     reserv: 1,
        //   },
        // }
      );

      const res =
        userType === "partner" || partnerRoleNew === "partner"
          ? JSON.parse(decryptData(getSearchDetail?.data))
          : ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNoNameFoundError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
    } finally {
      setScrollLoader(false);
      setBlankClientCodeError(false);
    }
  }
  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }
  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);
  //search api end

  const getDPReport = async (fileView, mainLoader = false) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");

    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: "stocks",
      flag: selection === "trade" ? "trans" : flag,
      selection: selection,
      dpType: depository
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
       Dashboard_Client_Report.DPReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setNoReportFound(false);
        if (fileView === "grid") {
          if (selection === "bill-tran") {
            if (flag === "tran") {
              setGridVal(res.data?.dpT);
            } else {
              setGridVal(res.data?.DpBill);
            }
          } else {
            setGridVal(res?.data?.DpList);
          }
        }
        if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
        if (fileView === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setGridVal([]);
          setNoReportFound(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (fileView !== "grid") {
        toast.error(error?.message);
      } else {
        setNoReportFound(error?.message);
        setGridVal([]);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };
console.log("clientcode",clientCode)
  const handleOnClick = (e) => {
    setShow(false);
    if (clientCode) {
      if (e.target.value) {
        if(selectDuration){
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getDPReport(e.target.value, true);
          setNoReportFound(false);
        } else {
          setDateErrorResp("Please Select Correct Date");
        }
      }
      else{
        setDateErrorResp("Please Select Duration");
      }
      }
    } else {
      setBlankClientCodeError("Please Enter Client Name/Code");
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    setDateErrorResp(false);
    setNoReportFound(false);
    setGridVal([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
  };

  const handleToDateChange = (e) => {
    setDateErrorResp(false);
    setNoReportFound(false);
    setGridVal([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
  };

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };
  const onChangeDuration=()=>{
    setDateErrorResp(false);
    setNoReportFound(false);
    setGridVal([]);

  }
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleSelectionChange = (e) => {
    setGridVal([]);
    setNoReportFound(false);
    setSelection(e.target.value);
  };

  const handleFlagOnChange = (e) => {
    setNoReportFound(false);
    setGridVal([]);
    if (e.target.value) {
      setFlag(e.target.value);
    }
  };

  const handleDepositoryChange = e => {
    setDepository(e.target.value);
    setNoReportFound(false);
    setGridVal([]);
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports dpreport">
        <div className="card-box">
          <div>
            <h2 className="report-title">DP Transaction Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setNoReportFound(false);
                    }}

                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScroll(e)}
                      >
                        {clientList &&
                          clientList.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              onClick={() => {
                                setClientCode(item?.clientCode);
                                setShow(false);
                              }}
                            >
                              {userType === "partner" || partnerRoleNew === "partner" ? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              : 
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                            </li>
                          ))}
                        {scrollLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                        {noNameFoundError && !scrollLoader && (
                          <li
                            className="rm-maping-item-wrapper"
                            style={{
                              borderBottom: "none",
                              fontSize: "12px",
                            }}
                          >
                            {noNameFoundError}
                          </li>
                        )}
                      </ul>
                    </>
                  )}
                </div>
                {blankClientCodeError && (
                  <span className="to-date-error">{blankClientCodeError}</span>
                )}
              </div>
            </div>
            <div className="col-md-4 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Selection:</label>
                <select
                  onChange={handleSelectionChange}
                  style={{ padding: "5px" }}
                >
                  <option value="bill-tran">Bill Transaction</option>
                  <option value="trade">Trade</option>
                </select>
              </div>
            </div>
            {selection === "bill-tran" && (
              <div className="col-md-4 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Flag:</label>
                  <select className="input-st" onChange={handleFlagOnChange}>
                    <option value="tran">Tran</option>
                    <option value="bill">Bill</option>
                  </select>
                </div>
              </div>
            )}

            <div className="col-md-4 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {dateErrorResp&& !selectDuration && (
                    <span className="duration-date-error">{dateErrorResp}</span>
                  )}
            </div>

            <div className="col-md-4 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">DP Type:</label>
                <select style={{ padding: "5px" }} onChange={handleDepositoryChange}>
                  {DP_TYPE_OPTIONS.map((opt) => {
                    return (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {customShow ?
              <div className="col-md-4 col-sm-3 col-6">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
              : null}
            {customShow ?
              <div className="col-md-4 col-sm-3 col-6">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={dateErrorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
              : null}
          </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            {" "}
            <ReportTableHeader
              smallLoaderMail={smallLoaderMail}
              showEmailBtn={true}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              gridVal &&
              gridVal.length > 0 && (
                <div>
                  <DpReportTable
                    gridVal={gridVal}
                    selection={selection}
                    flag={flag}
                  />
                </div>
              )
            )}
            {noReportFound && (
              <h4 className="report-error-message">
                {noDataFound(noReportFound)}
              </h4>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default DpReportSidebar;
